// extracted by mini-css-extract-plugin
export default {"productCarousal":"Carousels2_productCarousal__PoyCW","preBtn":"Carousels2_preBtn__tJlXq","nextBtn":"Carousels2_nextBtn__eVr57","myCardCaption":"Carousels2_myCardCaption__-ZqHp"};